module.exports = __webpack_public_path__ + "img/don40-min.f5aa1107.png";